module.exports = __webpack_public_path__ + "static/media/mcrcsm_logo.d8d80473.png";